import { CartStatus, ClaimRecordStatus } from '@typesApp/ClaimRecord'

export const isPollCartStatus = (status: ClaimRecordStatus | undefined): boolean => {
  return status === ClaimRecordStatus.INSURANCE_MEMBER_FOUND
}

export const isProductUpdateRequired = (cartStatus: CartStatus | undefined): boolean => {
  return cartStatus === CartStatus.PRODUCTS_UPDATE_REQUIRED
}
